import React, { useCallback, useEffect, useState } from "react";
import { getExchangeRate } from "../../services/rateService";
import { useLocation } from "react-router-dom";

export const ExchangeRate: React.FC = () => {
  const [rate, setRate] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const fetchRate = useCallback(async () => {
    try {
      setLoading(true);
      const result: number = await getExchangeRate("USDT", "RUB");
      setRate(result);
    } catch (error) {
      console.error("Failed to fetch exchange rate:", error);
    } finally {
      setLoading(false);
    }
  }, [setLoading, setRate]);

  useEffect(() => {
    fetchRate();
  }, [fetchRate, location.pathname]);

  return (
    <div className="mt-6 text-sm text-[#333] dark:text-gray-300 transition-colors duration-300">
      <div className="flex justify-between rounded-lg overflow-hidden mb-3 border border-gray-300 dark:border-gray-700">
        <button className="w-full py-2 text-center font-semibold bg-gray-100 dark:bg-gray-800 text-[#1f1f1f] dark:text-white transition-colors">
          RUB
        </button>
      </div>

      <div className="flex justify-between">
        <div>
          <p className="uppercase text-xs text-gray-500 dark:text-gray-400 mb-1">
            Buy
          </p>
          <p className="text-[#1f1f1f] dark:text-white font-semibold text-lg">
            {loading ? "..." : `${rate?.toFixed(2)} ₽`}
          </p>
        </div>
      </div>
    </div>
  );
};
